'use strict';

export default class Bounds {
  constructor(north, south, east, west) {
    this.north = north;
    this.south = south;
    this.east = east;
    this.west = west;
  }

  static fromString(str) {
    const getValue = (key) => {
      const start = str.indexOf(key + '=') + key.length + 1;
      let end = str.indexOf(',', start);
      if (end === -1) {
        end = str.indexOf(')', start); // last value ends before ")"
      }
      return parseFloat(str.substring(start, end).trim());
    };

    const north = getValue('north');
    const south = getValue('south');
    const east = getValue('east');
    const west = getValue('west');

    return new Bounds(north, south, east, west);
  }
}
